/** Each Preferences section's pane, loaded on first open. Shared by the full-page view the native shells use and the browser's modal. */
import type { ComponentType } from 'react';
import { lazyChunk } from '../../utils/lazyChunk';
import type { User } from '../../types/auth';
import type { PreferenceSectionId } from './preferenceSectionIds';

interface SectionProps { user: User }

export const SECTION_COMPONENTS: Record<PreferenceSectionId, ComponentType<SectionProps>> = {
  availability: lazyChunk(() => import('./sections/AvailabilitySection'), (m) => m.AvailabilitySection),
  notifications: lazyChunk(() => import('./sections/NotificationsSection'), (m) => m.NotificationsSection),
  'priority-contacts': lazyChunk(() => import('./sections/PriorityContactsSection'), (m) => m.PriorityContactsSection),
  navigation: lazyChunk(() => import('./sections/NavigationSection'), (m) => m.NavigationSection),
  appearance: lazyChunk(() => import('./sections/AppearanceSection'), (m) => m.AppearanceSection),
  messages: lazyChunk(() => import('./sections/MessagesSection'), (m) => m.MessagesSection),
  region: lazyChunk(() => import('./sections/RegionSection'), (m) => m.RegionSection),
  accessibility: lazyChunk(() => import('./sections/AccessibilitySection'), (m) => m.AccessibilitySection),
  'mark-as-read': lazyChunk(() => import('./sections/MessagesSection'), (m) => m.MessagesSection),
  privacy: lazyChunk(() => import('./sections/PrivacySection'), (m) => m.PrivacySection),
  advanced: lazyChunk(() => import('./sections/AdvancedSection'), (m) => m.AdvancedSection),
};
